import api from './api';

export const uploadFile = data => api.post('/costs/atualizacao-tabela-vendas/setFiles', data);

export const importTable = id => api.post('/costs/atualizacao-tabela-vendas/importTable', id);

